// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".premium-plan[data-v-6e1f6147]{border:.0625rem solid #167ea2;background-color:#fff}.label-cost[data-v-6e1f6147],.label-period[data-v-6e1f6147]{color:#8bbfd0;font-weight:400;font-size:1rem}", ""]);
// Exports
module.exports = exports;
